import { useAdmin } from './useAdmin';
import { useAgencyFeatures } from './useAgencyFeatures';

export function useWOpsAdminAccess() {
  const { isAdmin, loading: adminLoading } = useAdmin();
  const { showWOpsAdminTabs, loading: agencyLoading } = useAgencyFeatures();

  const loading = adminLoading || agencyLoading;

  return {
    canAccessWOpsAdminExtras: !loading && isAdmin && showWOpsAdminTabs,
    loading,
  };
}
